<template lang="pug">
.podcast-player
  el-dialog.podcast-player__dialog(
    visible
    @close="close"
    destroy-on-close
    append-to-body)
    .podcast-player__inner(
      v-if="video?.videoUrl"
      style="position: relative; padding-bottom: 56.25%; height: 0;")
      iframe(
        :src="video?.videoUrl"
        frameborder="0"
        webkitallowfullscreen
        mozallowfullscreen
        allowfullscreen
        allow="autoplay"
        style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;")
</template>

<script>
export default {
  props: {
    video: {
      type: [Object],
      required: true
    }
  },

  mounted () {
    this.$amplitude.track('OPEN_VIDEO_PLAYER', {
      video_id: this.video.id
    })
    this.$emit('open')
  },

  methods: {
    close () {
      this.$amplitude.track('CLOSE_VIDEO_PLAYER', {
        video_id: this.video.id
      })
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.podcast-player {
  &__loader {
    aspect-ratio: 16 / 9;
  }
  &__dialog {
    background: rgba(black, .9);
    ::v-deep {
      .el-dialog {
        position: relative;
        background: transparent;
        width: 1024px;
        margin: 0 auto;
        max-width: 100%;
        &__header {
          padding: 0;
        }
        &__close {
          position: fixed;
          color: white;
          border-radius: 100%;
          z-index: 1;
          top: 1em;
          right: 1em;
          font-size: 3rem;
        }
        &__body {
          padding: 0;
        }
      }
    }
  }
}
</style>
